export default __webpack_public_path__ + "static/media/User.f0715350.svg";